(function () {
  function initTrustpilot(root) {
    if (!window.Trustpilot) return;
    var nodes = (root || document).querySelectorAll('.trustpilot-widget:not([data-tp-loaded])');
    nodes.forEach(function (el) {
      try {
        window.Trustpilot.loadFromElement(el, true);
        el.setAttribute('data-tp-loaded', '1');
      } catch (e) {}
    });
  }

  // 1) Primer render
  if (document.readyState !== 'loading') initTrustpilot();
  else document.addEventListener('DOMContentLoaded', function () { initTrustpilot(); });

  // 2) Cuando el tema carga secciones/vista previa
  document.addEventListener('shopify:section:load', function (e) { initTrustpilot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { initTrustpilot(e.target); });

  // 3) Mutations (pilla “Cargar más”, infinitescroll, etc.)
  var obs = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) initTrustpilot(n);
        });
      }
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
